import React, {useState, useEffect} from 'react'
import { BrowserMultiFormatReader, BarcodeFormat, DecodeHintType } from '@zxing/library'
import { Select } from 'antd'

interface param {
    getDataScan: Function
}

type Props = param

const { Option } = Select
const formats = [
    BarcodeFormat.QR_CODE
]
const hints = new Map()
hints.set(DecodeHintType.POSSIBLE_FORMATS, formats)
const codeReader = new BrowserMultiFormatReader(hints)
const QRCode: React.FC<Props> = (props: Props) => {
    const [chooseCamera, setChooseCamera] = useState<string>('')
    const [listCamera, setListCamera] = useState<MediaDeviceInfo[]>([])
    const [screen, setScreen] = useState(window.innerWidth)
    const [width, setWidth] = useState<any>(500)
    const [firstDeviceId, setFirstDeviceId] = useState<string>('')

    useEffect(() => {
        codeReader
            .listVideoInputDevices()
            .then(videoInputDevices => {
                setListCamera(videoInputDevices)
                videoInputDevices.forEach(() => {
                    setFirstDeviceId(videoInputDevices[videoInputDevices.length - 1].deviceId)
                    codeReader
                        .decodeOnceFromVideoDevice(firstDeviceId, 'video')
                        .then(result => {
                            if (props.getDataScan && result !== null) {
                                props.getDataScan(result.getText())
                                console.log(result.getText())
                                codeReader.reset()
                            }
                        })
                        .catch(() => null)
                }
                )
            })
            .catch(err => console.error(err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstDeviceId])

    useEffect(() => {
        codeReader
            .listVideoInputDevices()
            .then(videoInputDevices => {
                videoInputDevices.forEach(() => {
                    codeReader
                        .decodeOnceFromVideoDevice(chooseCamera, 'video')
                        .then(result => {
                            if (props.getDataScan && result !== null) {
                                props.getDataScan(result.getText())
                                codeReader.reset()
                            }
                        })
                        .catch(() => null)
                }
                )
            })
            .catch(err => console.error(err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chooseCamera, props])

    useEffect(() => {
        setScreen(window.innerWidth)
        if (screen > 560) {
            setWidth(500)
        } else if (screen > 500) {
            setWidth(450)
        } else if (screen > 450) {
            setWidth(410)
        } else if (screen > 350) {
            setWidth(320)
        } else if (screen > 300) {
            setWidth(250)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screen])

    const handleChange = (value: any) => {
        setChooseCamera(value)
    }

    return (
        <div>
            Choose Camera : <Select placeholder="-- Select a Camera --" defaultValue={firstDeviceId || undefined} style={{ width: 200 }} onChange={handleChange}>
                {listCamera.map((it, index) => {
                    return <Option value={it.deviceId} key={index}>{it.label}</Option>
                })}
            </Select>
            <br /><br />

            <video
                id="video"
                width={width}
                height={width}
                style={{ border: '1px solid gray' }}
            >
            </video>
        </div>
    )
}

export default QRCode
